import React from 'react';
import ContactCard from './ContactCard/ContactCard';
import { Box } from '@mui/material';
import { Contact } from 'model/contacts.model';

const ContactsGrid = ({
  onViewDetails,
  data,
  onDelete,
  onEdit,
}: {
  onViewDetails: (contact: Contact) => void;
  data: Contact[];
  onDelete: (contact: any, alertText: any) => void;
  onEdit: (contact: any) => void;
}) => {
  return (
    <Box
      sx={{
        display: 'grid',

        gridTemplateColumns: {
          xs: 'repeat(auto-fill, minmax(250px, 1fr))', // Responsive columns
          sm: 'repeat(auto-fill, minmax(270px, 1fr))',
          md: 'repeat(auto-fill, minmax(280px, 1fr))',
          lg: 'repeat(auto-fill, minmax(290px, 1fr))',
          xl: 'repeat(auto-fill, minmax(300px, 1fr))',
        },
        gap: '24px',
        overflowY: 'auto',
        gridAutoRows: 'min-content', // Make rows only as tall as content
        gridAutoFlow: 'row',
        // height: '65vh',
        height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 250px)' },
        alignItems: 'start',
        '& > a': {
          // Target all Link elements directly inside the grid
          height: 'auto',
          display: 'block',
        },
      }}
    >
      {data.map((contact) => (
        <ContactCard
          key={contact.contactId}
          onViewDetails={onViewDetails}
          contact={contact}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </Box>
  );
};

export default ContactsGrid;
